export const DEFAULT_LEADERBOARD_DISPLAY_CONFIG_BY_SPORT = {
  Basketball: [
    {
      key: "points",
      title: "Point Leaders",
      endpoint: "/api/records/top20Points",
      valueKey: "totalPoints",
      valueLabel: "PTS",
      type: "player",
    },
    {
      key: "assists",
      title: "Assist Leaders",
      endpoint: "/api/records/top20Assists",
      valueKey: "totalAssists",
      valueLabel: "AST",
      type: "player",
    },
    {
      key: "rebounds",
      title: "Rebound Leaders",
      endpoint: "/api/records/top20Rebounds",
      valueKey: "totalRebounds",
      valueLabel: "REB",
      type: "player",
    },
    {
      key: "steals",
      title: "Steal Leaders",
      endpoint: "/api/records/top20Steals",
      valueKey: "totalSteals",
      valueLabel: "STL",
      type: "player",
    },
    {
      key: "blocks",
      title: "Block Leaders",
      endpoint: "/api/records/top20Blocks",
      valueKey: "totalBlocks",
      valueLabel: "BLK",
      type: "player",
    },
    {
      key: "threes",
      title: "3 Point Leaders",
      endpoint: "/api/records/top20Threes",
      valueKey: "totalThrees",
      valueLabel: "3PM",
      type: "player",
    },
    {
      key: "teamWins",
      title: "Team Leaders",
      endpoint: "/api/records/top20TeamWins",
      valueKey: "wins",
      valueLabel: "Wins",
      type: "team",
    },
  ],

  Volleyball: [
    {
      key: "kills",
      title: "Kills Leaders",
      endpoint: "/api/records/top20Kills",
      valueKey: "totalKills",
      valueLabel: "K",
      type: "player",
    },
    {
      key: "assists",
      title: "Assist Leaders",
      endpoint: "/api/records/top20Assists",
      valueKey: "totalAssists",
      valueLabel: "AST",
      type: "player",
    },
    {
      key: "digs",
      title: "Dig Leaders",
      endpoint: "/api/records/top20Digs",
      valueKey: "totalDigs",
      valueLabel: "DIG",
      type: "player",
    },
    {
      key: "blocks",
      title: "Block Leaders",
      endpoint: "/api/records/top20Blocks",
      valueKey: "totalBlocks",
      valueLabel: "BLK",
      type: "player",
    },
    {
      key: "aces",
      title: "Ace Leaders",
      endpoint: "/api/records/top20Aces",
      valueKey: "totalAces",
      valueLabel: "ACE",
      type: "player",
    },
  ],

  Baseball: [
    {
      key: "hits",
      title: "Hits Leaders",
      endpoint: "/api/records/top20Hits",
      valueKey: "totalHits",
      valueLabel: "H",
      type: "player",
    },
    {
      key: "runs",
      title: "Runs Leaders",
      endpoint: "/api/records/top20Runs",
      valueKey: "totalRuns",
      valueLabel: "R",
      type: "player",
    },
    {
      key: "rbi",
      title: "RBI Leaders",
      endpoint: "/api/records/top20Rbi",
      valueKey: "totalRbi",
      valueLabel: "RBI",
      type: "player",
    },
    {
      key: "homeRuns",
      title: "Home Run Leaders",
      endpoint: "/api/records/top20HomeRuns",
      valueKey: "totalHomeRuns",
      valueLabel: "HR",
      type: "player",
    },
    {
      key: "stolenBases",
      title: "Stolen Base Leaders",
      endpoint: "/api/records/top20StolenBases",
      valueKey: "totalStolenBases",
      valueLabel: "SB",
      type: "player",
    },
  ],


  Tennis: [
    {
      key: "wins",
      title: "Win Leaders",
      endpoint: "/api/records/top20TennisWins",
      valueKey: "totalWins",
      valueLabel: "W",
      type: "player",
    },
    {
      key: "aces",
      title: "Ace Leaders",
      endpoint: "/api/records/top20TennisAces",
      valueKey: "totalAces",
      valueLabel: "ACE",
      type: "player",
    },

    {
      key: "forehandWinners",
      title: "Forehand Winners",
      endpoint: "/api/records/top20ForehandWinners",
      valueKey: "totalForehandWinners",
      valueLabel: "FW",
      type: "player",
    },
    {
      key: "backhandWinners",
      title: "Backhand Winners",
      endpoint: "/api/records/top20BackhandWinners",
      valueKey: "totalBackhandWinners",
      valueLabel: "BW",
      type: "player",
    },
    {
      key: "shotConsistency",
      title: "Shot Consistency",
      endpoint: "/api/records/top20ShotConsistency",
      valueKey: "consistencyPercentage",
      valueLabel: "%",
      type: "player",
    },
  ],

};